import { render } from "./PropertyView.vue?vue&type=template&id=37a90fd7&scoped=true"
import script from "./PropertyView.vue?vue&type=script&lang=js"
export * from "./PropertyView.vue?vue&type=script&lang=js"

import "./PropertyView.vue?vue&type=style&index=0&id=37a90fd7&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37a90fd7"]])

export default __exports__